var _ellipse, _path, _line, _path2, _path3, _line2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 39,
    viewBox: "0 0 22 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1597,
    cy: 7.28332,
    rx: 7.67536,
    ry: 7.28332,
    fill: "#3B00D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2423 21.1005C21.2423 21.7893 21.2183 23.1464 20.5309 24.318C19.8845 25.4196 18.5698 26.4891 15.6772 26.4613C11.9196 26.4252 8.09788 25.3098 5.21098 24.0154C3.76889 23.3688 2.58245 22.6875 1.76853 22.0927C1.35956 21.7938 1.06418 21.5308 0.878749 21.3194C0.780676 21.2076 0.734147 21.1338 0.712545 21.095C0.738307 21.0509 0.802271 20.9573 0.958484 20.8124C1.21423 20.5753 1.61279 20.2976 2.1464 19.9936C3.20768 19.3889 4.69265 18.7416 6.33952 18.1456C9.65457 16.9459 13.4553 16.0148 15.5785 16.0148C17.843 16.0148 19.2352 16.9953 20.0807 18.1111C20.9544 19.2639 21.2423 20.5621 21.2423 21.1005Z",
    stroke: "black",
    strokeWidth: 1.39294
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.15034,
    y1: 20.9285,
    x2: 14.3832,
    y2: 16.0532,
    stroke: "black",
    strokeWidth: 1.39294
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39285 21.8835L14.7466 26.4609",
    stroke: "black",
    strokeWidth: 1.39294
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.697184 32.9481C0.697184 33.637 0.721127 34.9941 1.40855 36.1657C2.05494 37.2673 3.36964 38.3368 6.26223 38.309C10.0199 38.2729 13.8416 37.1575 16.7285 35.8631C18.1706 35.2165 19.357 34.5352 20.1709 33.9403C20.5799 33.6414 20.8753 33.3785 21.0607 33.167C21.1588 33.0552 21.2053 32.9814 21.2269 32.9426C21.2011 32.8985 21.1372 32.805 20.981 32.6601C20.7252 32.4229 20.3267 32.1453 19.7931 31.8413C18.7318 31.2366 17.2468 30.5892 15.5999 29.9933C12.2849 28.7936 8.48416 27.8625 6.36091 27.8625C4.09647 27.8625 2.70426 28.843 1.85874 29.9587C0.98509 31.1116 0.697184 32.4097 0.697184 32.9481Z",
    stroke: "black",
    strokeWidth: 1.39294
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.696468,
    x2: 14.1024,
    y2: -0.696468,
    transform: "matrix(-0.938343 -0.345705 -0.345705 0.938343 20.5483 33.4297)",
    stroke: "black",
    strokeWidth: 1.39294
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5466 33.7311L7.19284 38.3086",
    stroke: "black",
    strokeWidth: 1.39294
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d92e863e983c91c6113e42d236572805.svg";
export { ForwardRef as ReactComponent };